import React from 'react';
import { Icon } from './Icon.js';
export const IconChatBubbleFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.75.501H3.25C1.733.501.5,1.735.5,3.251v8c0,.297.175.566.447.686.097.043.201.064.303.064.183,0,.364-.067.504-.195l2.536-2.305h4.46c1.517,0,2.75-1.233,2.75-2.75v-3.5c0-1.517-1.233-2.75-2.75-2.75Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconChatBubbleFill12.js.map